import '../styles/quick-book.scss'
import { Button, ButtonColor } from '@vista-digital/occ-ui'
import type { FC } from 'react'
import { useState } from 'react'
import { useInitialDataHeader } from '@/common/hooks/useInitialData'
import { QuickBookPropsApi } from '@/features/layout/header/models'
import { QuickBookModal } from '@/features/layout/header/subcomponents/quickBookModal/QuickBookModal'
import { navigationMenuStore } from '@/features/layout/stores/navigationMenu.store'

export const QuickBook: FC = () => {
    const { quickBook = new QuickBookPropsApi() } = useInitialDataHeader()

    const [isOpen, setIsOpen] = useState(false)
    const closeModal = () => setIsOpen(false)
    const openModal = () => {
        setIsOpen(true)
        navigationMenuStore.hideNavMenu()
    }
    return (
        <span className="quick-book">
            <Button
                label={quickBook.headingLabel}
                className="quick-book__button"
                color={ButtonColor.Primary}
                onClick={openModal}
            />
            <QuickBookModal isOpen={isOpen} onClose={closeModal} />
        </span>
    )
}
